/**
 * Styled Components - Created by eduardoquintero on 25/08/20.
 */
import styled from 'styled-components'
import { RED, GRAY_DARK, GRAY, RED_BRIGHT, BLUE, WHITE, RED_LIGHT, RED_SOFT } from '../../../theme/colors'
import Button from 'antd/lib/button'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px;
  position: relative;
  cursor: pointer;
  background: ${WHITE};
  justify-content: space-between;

  &.new {
    background: ${RED_BRIGHT};
  }
`

export const Title = styled.div`
  color: ${GRAY_DARK};
  font-size: 14px;
  margin-right: 5px;
  font-weight: 600;
  text-transform: uppercase;
`

export const RedDot = styled.div`
  width: 8px;
  height: 8px;
  background: ${RED};
  border-radius: 6px;
`

export const Description = styled.div`
  color: ${GRAY_DARK};
  font-size: 14px;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 93%;
  b {
    color: ${BLUE};
    transition: all .25s;
    &:hover {
      opacity: 0.5;
      cursor: pointer;
    }
  }
  i {
    font-style: normal !important;
    font-weight: bold;
  }
`

export const Date = styled.div`
  color: ${GRAY};
  font-size: 12px;
  margin-bottom: 5px;
`

export const Row = styled.div`
`

export const SwipeItemLi = styled.div`
  position: relative;
  overflow: hidden;
`

export const SwipeItemContent = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 200;
`

export const DeleteButton = styled(Button).attrs({
  type: 'default', icon: 'delete', size: 'small'
})`
  padding: 0 12px;
  height: 26px;

  @media (max-width: 767px) {
    color: ${RED_LIGHT};
    border-color: ${RED_SOFT};
  }
`

export const ColumnFlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
`

export const CenterAlignedFlexContainer = styled.div`
  display: flex;
  align-items: center;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/NotificationHeader/NotificationRow/styledComponents.tsx